/**
 * Iter 87 - Composant d'invitation d'artisan depuis la fiche projet.
 * Permet de creer un compte artisan + recuperer les identifiants temporaires
 * (CEO/admin uniquement). L'artisan voit ensuite ses interventions des qu'on
 * lui en attribue une dans Budget Travaux (via le champ artisan_email).
 */
import React, { useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ArtisanInvitePanel = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ email: '', company_name: '', contact_name: '', phone: '' });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email) return;
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const r = await axios.post(`${API}/artisan/invite`, form);
      setResult(r.data);
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    } finally { setLoading(false); }
  };

  const reset = () => {
    setOpen(false);
    setForm({ email: '', company_name: '', contact_name: '', phone: '' });
    setResult(null);
    setError(null);
  };

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="px-3 py-1.5 text-xs font-semibold bg-[#A57F4F] text-white rounded hover:bg-[#8d6a40] transition"
        data-testid="artisan-invite-btn"
      >
        + Inviter une entreprise travaux
      </button>
    );
  }

  return (
    <div className="realease-card p-4 border-2 border-[#A57F4F]/30" data-testid="artisan-invite-panel">
      <div className="flex items-center justify-between mb-3">
        <h4 className="font-semibold text-gray-900">Inviter une entreprise travaux</h4>
        <button onClick={reset} className="text-gray-500 hover:text-gray-700" data-testid="artisan-invite-close">✕</button>
      </div>
      {!result && (
        <form onSubmit={submit} className="space-y-3">
          <p className="text-xs text-gray-500">
            Cree un compte d&apos;acces. L&apos;artisan verra automatiquement les interventions ou son email
            est saisi (champ Email artisan dans Budget Travaux).
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <input type="email" required placeholder="Email (obligatoire)" value={form.email}
                   onChange={(e) => setForm({ ...form, email: e.target.value })}
                   className="realease-input text-sm" data-testid="artisan-invite-email" />
            <input type="text" placeholder="Nom entreprise" value={form.company_name}
                   onChange={(e) => setForm({ ...form, company_name: e.target.value })}
                   className="realease-input text-sm" data-testid="artisan-invite-company" />
            <input type="text" placeholder="Nom contact" value={form.contact_name}
                   onChange={(e) => setForm({ ...form, contact_name: e.target.value })}
                   className="realease-input text-sm" data-testid="artisan-invite-contact" />
            <input type="tel" placeholder="Telephone" value={form.phone}
                   onChange={(e) => setForm({ ...form, phone: e.target.value })}
                   className="realease-input text-sm" data-testid="artisan-invite-phone" />
          </div>
          <button type="submit" disabled={loading || !form.email}
                  className="px-4 py-2 rounded-md bg-[#A57F4F] text-white text-sm font-semibold hover:bg-[#8d6a40] disabled:opacity-50 transition"
                  data-testid="artisan-invite-submit">
            {loading ? 'Creation...' : 'Creer le compte artisan'}
          </button>
          {error && <p className="text-red-600 text-sm" data-testid="artisan-invite-error">{error}</p>}
        </form>
      )}
      {result && (
        <div className="space-y-2" data-testid="artisan-invite-result">
          {result.created ? (
            <>
              <div className="p-3 rounded bg-emerald-50 border border-emerald-200 text-sm">
                <p className="font-semibold text-emerald-800">Compte cree avec succes</p>
                <p className="text-emerald-700 mt-1">{result.instructions}</p>
              </div>
              <div className="p-3 rounded bg-gray-50 border border-gray-200 font-mono text-xs space-y-1">
                <div><span className="text-gray-500">Email :</span> <b className="text-gray-800">{result.user?.email}</b></div>
                <div><span className="text-gray-500">Mot de passe :</span> <b className="text-gray-800" data-testid="artisan-invite-password">{result.temp_password}</b></div>
                <div><span className="text-gray-500">URL :</span> <a href="/login" className="text-[#A57F4F]">{window.location.origin}/login</a></div>
              </div>
              <p className="text-[11px] text-gray-500">
                Transmettez ces identifiants par email/SMS/WhatsApp. L&apos;artisan se connectera sur la page de connexion standard.
                Pour qu&apos;il voie un projet, ajoutez son email dans le champ <b>Email artisan</b> sur chaque intervention du Budget Travaux.
              </p>
            </>
          ) : (
            <div className="p-3 rounded bg-amber-50 border border-amber-200 text-sm text-amber-800">
              {result.message}
            </div>
          )}
          <button type="button" onClick={reset} className="text-xs text-gray-600 hover:underline">Fermer</button>
        </div>
      )}
    </div>
  );
};

export default ArtisanInvitePanel;
